import { useTheme } from '@/context/ThemeContext';

export default function CaseStudies() {
  const { isDark } = useTheme();

  const cases = [
    { industry: 'Trade Services Company', result: 'Automated lead capture and dispatch coordination, increasing booked jobs by 38%.', metric: '+38%', metricLabel: 'Booked Jobs', icon: 'ri-tools-fill' },
    { industry: 'Clinical Practice', result: 'Implemented automated patient intake and scheduling, reducing administrative workload by 60%.', metric: '-60%', metricLabel: 'Admin Workload', icon: 'ri-heart-pulse-fill' },
    { industry: 'Brokerage Firm', result: 'Built an AI-driven deal pipeline system that automated follow-ups and improved conversion rates.', metric: '+42%', metricLabel: 'Conversion Rate', icon: 'ri-line-chart-fill' },
  ];

  return (
    <section
      id="case-studies"
      className={`py-32 px-6 relative overflow-hidden transition-colors duration-500 ${isDark ? 'bg-[#0A1219]' : 'bg-white'}`}
    >
      {/* Ambient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#14B8A6]/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <div className="text-[#14B8A6] text-xs font-semibold tracking-[0.2em] uppercase mb-4">PROVEN RESULTS</div>
          <h2 className={`text-5xl md:text-7xl font-bold mb-6 tracking-tight transition-colors duration-500 ${isDark ? 'text-white' : 'text-[#0D1B2A]'}`}>
            Operational Impact
          </h2>
          <p className={`text-xl max-w-2xl mx-auto leading-relaxed transition-colors duration-500 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            Real businesses achieving measurable results through intelligent automation.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {cases.map((caseStudy, index) => (
            <div
              key={index}
              className={`relative backdrop-blur-xl border rounded-3xl p-10 transition-all duration-700 hover:scale-[1.02] cursor-pointer group overflow-hidden ${
                isDark
                  ? 'bg-gradient-to-br from-[#14B8A6]/5 via-[#0D1B2A]/50 to-[#0D1B2A]/80 border-white/5 hover:border-[#14B8A6]/30'
                  : 'bg-white border-gray-100 hover:border-[#14B8A6]/40 hover:shadow-2xl'
              }`}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-[#14B8A6]/0 to-[#14B8A6]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-700 rounded-3xl" />
              <div className="relative z-10">
                <div className="w-14 h-14 flex items-center justify-center bg-[#14B8A6]/10 rounded-2xl mb-8 group-hover:bg-[#14B8A6]/20 group-hover:scale-110 transition-all duration-500">
                  <i className={`${caseStudy.icon} text-3xl text-[#14B8A6]`} />
                </div>
                <div className="mb-6">
                  <div className="text-7xl md:text-8xl font-bold text-[#14B8A6] mb-2 tracking-tighter leading-none">
                    {caseStudy.metric}
                  </div>
                  <div className={`text-sm font-medium tracking-wide uppercase transition-colors duration-500 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                    {caseStudy.metricLabel}
                  </div>
                </div>
                <h3 className={`text-2xl font-bold mb-4 tracking-tight transition-colors duration-500 ${isDark ? 'text-white' : 'text-[#0D1B2A]'}`}>
                  {caseStudy.industry}
                </h3>
                <p className={`text-base leading-relaxed transition-colors duration-500 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                  {caseStudy.result}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
